export default "__VITE_ASSET__DxjafE9u__"